import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import { CaseDrawer } from "@/components/kanban/CaseDrawer";
import type { Case } from "@/lib/useRealtimeCases";
export default function ReminderCasePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [row, setRow] = useState<Case | null>(null),
    [error, setError] = useState("");
  // Fermeture : retour à la page d'où l'on vient (Manager, Kanban…) si l'historique de
  // l'application le permet, sinon le Kanban (lien ouvert directement).
  const closeCase = () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx;
    if (typeof idx === "number" && idx > 0) navigate(-1);
    else navigate("/kanban");
  };
  useEffect(() => {
    let alive = true;
    setRow(null);
    setError("");
    void supabase
      .from("cases")
      .select("*")
      .eq("id", id!)
      .single()
      .then(({ data, error }) => {
        if (!alive) return;
        if (error) setError("Ce dossier n’est plus accessible.");
        else setRow(data);
      });
    return () => {
      alive = false;
    };
  }, [id]);
  return (
    <>
      <div className="p-8 text-sm text-gray-500">
        {error || "Ouverture du dossier associé à votre rappel…"}
        {error && (
          <button className="ml-3 underline" onClick={() => navigate("/kanban")}>
            Revenir au Kanban
          </button>
        )}
      </div>
      {row && <CaseDrawer case={row} onClose={closeCase} />}
    </>
  );
}
